import {
  HttpInterceptor,
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpHeaders,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable, Inject, LOCALE_ID } from '@angular/core';

@Injectable()
export class LocalizationHttpInterceptor implements HttpInterceptor {
  constructor(@Inject(LOCALE_ID) private locale: string) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let modifiedHeaders = new HttpHeaders();
    modifiedHeaders = req.headers
      .set('Pragma', 'no-cache')
      .set('Cache-Control', 'no-cache')
      .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT');
    // Public-onboarding-only culture override.
    //
    // In prod, FE and backend share an origin so /AbpLocalization/ChangeCulture
    // sets the `.AspNetCore.Culture` cookie and CookieRequestCultureProvider
    // picks it up — no header needed. In dev they're cross-origin (4200 ↔ 5000)
    // and Chrome blocks the SameSite=Lax cookie from being sent back, so the
    // onboarding store mirrors the chosen culture into
    // `localStorage.onboarding-culture` and we resend it here as the
    // `.AspNetCore.Culture` request header, which AbpLocalizationHeaderRequestCultureProvider
    // on the backend reads.
    //
    // Strictly scoped to /onboarding/* pathname AND requires the localStorage
    // flag to be set — so logged-in app traffic never carries this header and
    // stays fully driven by AbpUserRequestCultureProvider (DB user setting).
    // We deliberately do NOT touch Accept-Language; that header is owned by
    // the browser and using it as a transport here can fight other behaviour.
    if (this.isOnboardingContext()) {
      const override = this.resolveOnboardingCulture();
      if (override) {
        modifiedHeaders = this.addAspNetCoreCultureHeader(
          modifiedHeaders,
          override
        );
      }
    }
    return next.handle(
      req.clone({
        headers: modifiedHeaders,
      })
    );
  }

  protected isOnboardingContext(): boolean {
    try {
      return /^\/onboarding(\/|$)/.test(window.location.pathname);
    } catch {
      return false;
    }
  }

  protected resolveOnboardingCulture(): string | null {
    try {
      return localStorage.getItem('onboarding-culture');
    } catch {
      return null;
    }
  }

  protected addAspNetCoreCultureHeader(
    headers: HttpHeaders,
    culture: string
  ): HttpHeaders {
    if (this.locale && headers && !headers.has('.AspNetCore.Culture')) {
      headers = headers.set('.AspNetCore.Culture', culture);
    }
    return headers;
  }
}
